import mixpanelAnalytics from 'Utils/mixpanel';

mixpanelAnalytics.init();

if (typeof window !== 'undefined') {
    window.vumedi = window.vumedi || {};
    if (!window.vumedi.mixpanel) {
        Object.defineProperty(window.vumedi, 'mixpanel', {
            value: mixpanelAnalytics,
            writable: false,
            configurable: false,
            enumerable: true,
        });
    }
}
